import { yClosestMatch } from './string';

const common_domains = [
    'gmail.com', //1129
    'hotmail.com', //555
    'telia.com', //135
    'live.com', //68
    'comhem.se', //63
    'yahoo.se', //60
    'hotmail.se', //45
    'bredband.net', //35
    'icloud.com', //31
    'yahoo.com', //26
    'outlook.com', //26
    'me.com', //25
    'spray.se', //23
    'tele2.se', //19
    'live.com', //12
    'swipnet.se', //11
    'ownit.nu', //8
    'msn.com', //8
    'home.se', //8
    'mac.com', //7
    'bahnhof.se', //5
    'glocalnet.net', //4
    'ymail.com', //3
];

const toplevel_domains = [
    'com'
]

interface EmailComponents {
    name: string;
    domain: string;
    tld: string;
    sld: string;
}

function splitEmail(email: string): EmailComponents | undefined {
    email = email.trim();
    const parts = email.split('@');

    if(parts.length < 2) return;
    if(!parts[0] || !parts[1]) return;

    const domain = parts[1].split('.');

    for(const part of domain) {
        if(!part) return;
    }

    const tld = domain.pop()!;
    const sld = domain.join('.');

    return {
        name: parts[0],
        domain: parts[1],
        tld: tld,
        sld: sld
    }
}

export function ySuggestEmail(email: string) {
    email = email.toLowerCase();
    const parts = splitEmail(email);
    if(!parts) return;

    //It matches one of the domains, return nothing
    if(common_domains.includes(parts.domain))
        return;

    const closest_domain = yClosestMatch(parts.domain, common_domains, 3);
    if(closest_domain)
        return parts.name + '@' + closest_domain;

    const closest_tld = yClosestMatch(parts.tld, toplevel_domains, 1);
    if(closest_tld)
        return parts.name + '@' + parts.sld + '.' + closest_tld;

    return;
}
